<template>
  <div>
    <v-container fluid class="px-12 py-4">
      <v-row>
        <v-col cols="6">
          <breadcrumbs></breadcrumbs>
          <h1>Security Roles</h1>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn
            :disabled="buildIsClosed"
            @click="navigate(null)"
            class="mt-5"
            color="primary"
            data-cy="addButton"
            outlined
            >Add</v-btn
          >
        </v-col>
      </v-row>
      <v-divider class="mb-10"></v-divider>
      <div v-if="!isOchinUser">
        <v-text-field label="Filter..." v-model="search" class="mt-5" outlined>
          <template v-slot:prepend-inner>
            <v-icon class="mr-3">fas fa-search</v-icon>
          </template> </v-text-field
        ><v-card outlined>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="roleList"
              :search="search"
              sort-by="name"
            >
              <template v-slot:item="{ item }">
                <tr @click="navigate(item.id)" class="och-tableRow">
                  <td>
                    <a>{{ item.name }}</a>
                  </td>
                  <td>
                   {{ displayTemplateName(item.securityTemplateId) }}
                  </td>
                  <td class="text-right">
                    <v-btn
                      @click.stop="setDialog(true, item.id)"
                      alt-text="Delete record"
                      color="primary"
                      outlined
                      small
                      title="Delete record"
                    >
                      Delete
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>

      <div v-else>
        <role-template-table :roleList="roleList"></role-template-table>
      </div>
    </v-container>
    <v-dialog v-model="dialog" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline">Delete Confirmation</v-card-title>
        <v-card-text>
          Are you sure you want to delete
          <span v-if="selectedRecord">{{ selectedRecord.name }}?</span>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn outlined @click="cancel" class="mr-2">Cancel</v-btn>
          <v-btn color="warning elevation-0 font-weight-bold" @click="submit()"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Breadcrumbs from "@/views/Breadcrumbs";
import RoleTemplateTable from "./RoleTemplateTable";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: { Breadcrumbs, RoleTemplateTable },
  computed: {
    buildIsClosed() {
      return this.organizationStatusIsGreaterThanOrEqualTo("buildClosed");
    },
    isOchinUser() {
      const { isOchinUser } = this.user;
      return isOchinUser;
    },
    ...mapGetters({
      filterOrganizationRoleAnswerByAttribute:
        "secRoleOrganizationSecAnswer/filterByAttributeValue",
      getRoleById: "secRoleOrganization/getById",
      getTemplateById: "template/getById",
      organizationStatusIsGreaterThanOrEqualTo:
        "organizationStatus/organizationStatusIsGreaterThanOrEqualTo",
    }),
    ...mapState({
      roleAnswerList: state => state.secRoleOrganizationSecAnswer.list,
      roleList: state => state.secRoleOrganization.list,
      user: state => state.session.user,
    }),
  },
  async created() {
    try {
      await Promise.all([this.fetchRoleList(), this.fetchRoleAnswerList(), this.fetchTemplateList(),]);
    } catch (e) {
      console.error(e);
      this.$notifyError({ message: "Unable to get data from server" });
    }
  },
  data() {
    return {
      dialog: false,
      headers: [
        {
          align: "start",
          text: "Name",
          value: "name",
        },
        {
          sortable: false,
          text: "Security Template",
          value: "matchingTemplate",
        },
        { sortable: false, text: "", value: "actions" },
      ],
      search: null,
      selectedRecord: null,
    };
  },
  methods: {
    cancel() {
      this.dialog = false;
    },
    displayTemplateName(securityTemplateId) {
      const template = this.getTemplateById(securityTemplateId);
      if (template) {
        return `${template.id} - ${template.name}`;
      }
      return "--";
    },
    filterOrganizationRoleAnswerList(secRoleOrganizationId) {
      const filteredList = this.filterOrganizationRoleAnswerByAttribute(
        "secRoleOrganizationId",
        secRoleOrganizationId
      );
      return filteredList;
    },
    navigate(id) {
      if (id) {
        this.$router.push({
          name: "organizationRoleEdit",
          params: { id },
        });
        return;
      }
      this.$router.push({
        name: "organizationRoleCreate",
      });
    },
    setDialog(val, id) {
      if (val === true) {
        this.selectedRecord = this.getRoleById(id);
      }
      this.dialog = val;
    },
    async submit() {
      const { id } = this.selectedRecord;
      try {
        // Before deleting the record, delete existing answer-role associations in table.
        const filteredRoleOrganizationAnswerList = this.filterOrganizationRoleAnswerList(
          id
        );
        for (const record of filteredRoleOrganizationAnswerList) {
          await this.deleteRoleAnswer(record.id);
        }
        await this.deleteRole(id);
        this.fetchRoleList();
        this.fetchRoleAnswerList();
      } catch (e) {
        console.error(e);
      }
      this.dialog = false;
      this.selectedRecord = null;
    },
    ...mapActions({
      deleteRole: "secRoleOrganization/remove",
      deleteRoleAnswer: "secRoleOrganizationSecAnswer/remove",
      fetchRoleAnswerList: "secRoleOrganizationSecAnswer/list",
      fetchRoleList: "secRoleOrganization/list",
      fetchTemplateList: "template/list",
    }),
  },
};
</script>
